import styled from 'styled-components';

const LIST_CONTAINER_MIN_HEIGHT = 424;

const COLUMN_FLEX: [column: string, flex: string][] = [
  ['name', '1 1 0'],
  ['country', '0 0 112px'],
  ['provider', '0 0 112px'],
  ['audience', '0 0 88px'],
  ['fee', '0 0 56px'],
  ['buttons', '0 0 72px']
];

const columnWidths = COLUMN_FLEX.map(([column, flex]) => `&--${column} { flex: ${flex}; }`).join('\n');

// Header titles are matched from the end (see the columns header comment)
const headerColumnWidths = COLUMN_FLEX.map(
  ([, flex], index) => `&:nth-last-child(${COLUMN_FLEX.length - index}) { flex: ${flex}; }`
).join('\n');

export const AudienceTargetingListStyled = styled.div`
  width: 60%;
  border-radius: 8px;
  background: var(--color-sonata-primary-200);
  display: flex;
  flex-direction: column;
  padding: var(--spacing-16);

  .audienceTargetingList {
    &__filters {
      display: flex;
      flex-direction: row;
      gap: var(--spacing-8);
      margin-bottom: var(--spacing-8);
    }

    &__selector {
      flex: 0 0 136px;
      max-width: 136px;
      min-width: 0;

      .multiSelector {
        min-width: 0;
      }

      .selectorComponent__value,
      .selectorComponent__placeholder {
        height: auto;
        line-height: 16px;
        min-width: 0;
      }

      .selectorComponent__indicators {
        align-items: center;
        line-height: 1;
      }
    }

    &__inputSearch {
      flex: 1 1 0;
      min-width: 0;
    }

    &__listContainer {
      flex: 1 1 auto;
      min-height: ${LIST_CONTAINER_MIN_HEIGHT}px;
      position: relative;
    }

    &__listContent {
      inset: 0;
      position: absolute;
    }

    &__nameContainer {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-4);
      min-width: 0;
    }

    &__name,
    &__description {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &__name {
      color: var(--color-sonata-primary-800);
      font: var(--font-body-400-bold);
    }

    &__description {
      color: var(--color-sonata-primary-600);
      font: var(--font-info-600-bold);
    }

    &__buttonsContainer {
      display: flex;
      flex-direction: row;
      gap: var(--spacing-8);
      justify-content: flex-end;
    }
  }

  && .audienceTargetingList__button.buttonWrapper {
    background-color: var(--color-sonata-primary-200);
    border: none;
    border-radius: 8px;
    height: 32px;
    min-width: 32px;
    width: 32px;

    .buttonWrapper__iconWrapper {
      color: var(--color-sonata-interaction-500);
    }

    &:hover .buttonWrapper__iconWrapper {
      color: var(--color-sonata-interaction-700);
    }

    &.audienceTargetingList__button--included,
    &.audienceTargetingList__button--excluded {
      cursor: default;

      .buttonWrapper__iconWrapper,
      &:hover .buttonWrapper__iconWrapper {
        color: var(--color-sonata-secondary-white);
      }
    }

    &.audienceTargetingList__button--included {
      background-color: var(--color-status-success-500);
    }

    &.audienceTargetingList__button--excluded {
      background-color: var(--color-status-error-550);
    }
  }

  /* Columns header. Its side margins match the rows area: 1px of tbody padding on both sides plus the 7px
     scrollbar gutter on the right (reserved with scrollbar-gutter even when there is no scroll) */
  [data-testid='columnsHeader'] {
    background-color: var(--color-sonata-primary-200);
    border: 1px solid var(--color-sonata-primary-400);
    border-radius: 8px;
    margin: 0 8px 0 1px;
    padding: var(--spacing-8) var(--spacing-16);

    .columnsHeaderContainer {
      gap: var(--spacing-4);
      justify-content: flex-start;

      &__title {
        align-items: center;
        color: var(--color-sonata-primary-600);
        display: flex;
        font: var(--font-body-400-bold);
        gap: var(--spacing-8);
        margin-left: 0;
        min-width: 0;
        white-space: nowrap;

        /* Counted from the end: the select all Checkbox renders a <style> element before it, so nth-child
           would be shifted */
        ${headerColumnWidths}

        /* Buttons column: keeps its width but has no title nor sorting */
        &:last-child {
          visibility: hidden;
        }
      }

      &__icon {
        padding: 0 !important;
      }
    }

    /* Checkbox puts the class on both its container and its inner wrapper: keep the padding only once,
       as in the rows checkbox cell */
    .columnsHeaderActionContainerCheckbox {
      padding: 0 var(--spacing-8) 0 0;

      .columnsHeaderActionContainerCheckbox {
        padding: 0;
      }
    }
  }

  .listTbody {
    scrollbar-gutter: stable;
  }

  .listTbody .listTbodyRow {
    background-color: var(--color-sonata-secondary-white);
    border: 1px solid var(--color-sonata-primary-400);
    border-radius: 8px;
    gap: var(--spacing-4);
    min-height: 48px;
    padding: var(--spacing-8) var(--spacing-16);

    & > .listTbodyCell:first-child {
      padding: 0 var(--spacing-8) 0 0;
    }

    .audienceTargetingList__cell {
      color: var(--color-sonata-primary-600);
      font: var(--font-body-400-regular);
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      > div {
        overflow: hidden;
        text-overflow: ellipsis;
      }

      ${columnWidths}
    }
  }
`;
